import { render, staticRenderFns } from "./AlbumList.vue?vue&type=template&id=54b3468b&"
import script from "./AlbumList.vue?vue&type=script&lang=ts&"
export * from "./AlbumList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports